import { render } from "./Group.vue?vue&type=template&id=b97caeae&scoped=true"
import script from "./Group.vue?vue&type=script&lang=js"
export * from "./Group.vue?vue&type=script&lang=js"

import "./Group.vue?vue&type=style&index=0&id=b97caeae&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b97caeae"]])

export default __exports__